// LIBRARIES
import dayjs from "dayjs";

//REDUX
import { createSlice } from "@reduxjs/toolkit";
import { getAllRentals } from "api/rentalApi";

//MISC
import { IRental, IRentalApiParams, RentalsTableData } from "models/interfaces";
import { t } from "i18next";
import moment from "moment";

export interface ISessionInitialState {
  rentals: IRental;
  isLoading: boolean;
  errorMessage: string;
  rentalTotalPages: number;
  rentalsTableData: RentalsTableData[];
  rentalFilters: IRentalApiParams;
  selectedRentalReportType: string;
}

const initialState: ISessionInitialState = {
  rentals: {
    content: [],
    pageable: {
      sort: {
        empty: false,
        sorted: false,
        unsorted: false,
      },
      offset: 0,
      pageNumber: 0,
      pageSize: 0,
      paged: false,
      unpaged: false,
    },
    totalPages: 0,
    totalElements: 0,
    last: false,
    size: 0,
    number: 0,
    sort: {
      empty: false,
      sorted: false,
      unsorted: false,
    },
    numberOfElements: 0,
    first: false,
    empty: false,
    startPhotoPath: "",
    endPhotoPath: "",
  },
  isLoading: false,
  errorMessage: "",
  rentalTotalPages: 0,
  rentalsTableData: [],
  rentalFilters: {
    userFullName: {
      usernameOrPhoneNumber: "",
    },
    lockerId: "",
    startDate: "",
    endDate: "",
    page: "",
  },
  selectedRentalReportType: "",
};

export const rentalSlice = createSlice({
  name: "rental",
  initialState,
  reducers: {
    toggleRentalFiltersUserFullNameState: (state, action) => {
      state.rentalFilters.userFullName = action.payload;
    },
    toggleRentalFiltersLockerIdState: (state, action) => {
      state.rentalFilters.lockerId = action.payload;
    },
    toggleRentalFiltersStartDateState: (state, action) => {
      state.rentalFilters.startDate = action.payload;
    },
    toggleRentalFiltersEndDateState: (state, action) => {
      state.rentalFilters.endDate = action.payload;
    },
    toggleRentalFiltersPageState: (state, action) => {
      state.rentalFilters.page = action.payload;
    },
    toggleClearRentallFiltersState: (state) => {
      state.rentalFilters = {
        userFullName: {
          usernameOrPhoneNumber: "",
        },
        lockerId: "",
        startDate: "",
        endDate: "",
        page: "",
      };
    },
    toggleClearRentalsTableData: (state) => {
      state.rentalsTableData = null;
    },
    toggleSelectedRentalReportType: (state, action) => {
      state.selectedRentalReportType = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(getAllRentals.pending, (state) => {
      state.isLoading = true;
      state.errorMessage = "";
    });
    builder.addCase(getAllRentals.fulfilled, (state, action) => {
      state.isLoading = false;
      let data = action.payload.content;
      console.log(data)
      let initialData = Array.from({ length: data.length }, () => ({
        fullName: "",
        slotId: "",
        date: "",
        startTime: "",
        endTime: "",
        duration: "",
        // amount: "10",
        rentalId: 0,
      }));
      data.forEach((item, index) => {
        let duration = (item.endTime ? moment.duration(moment(item.endTime).diff(moment(item.startTime))) : moment.duration(moment().diff(moment(item.startTime))));
        let formattedDuration = moment.utc(duration.asMilliseconds()).format("HH:mm:ss");
        initialData[index] = {
          fullName: item?.user?.fullName || "NO_NAME_PROVIDED",
          slotId: item.slot == null
            ? "no slot"
            : item.isDoubleRental && (!item.slot.identificationNumber || !item.secondSlot?.identificationNumber)
              ? "no slot"
              : `${item.isDoubleRental ? `${item.slot.identificationNumber}, ${item.secondSlot.identificationNumber}` : `${item.slot.identificationNumber}`}`, date: dayjs(item.startTime).format("DD/MM/YYYY"),
          startTime: dayjs(item.startTime).format("HH:mm:ss"),
          endTime:
            item.endTime != null
              ? dayjs(item.endTime).format("HH:mm:ss")
              : t("modal.rentalDetails.inProgress"),
          duration: formattedDuration,
          // amount: "0 RON",
          rentalId: item.id,
        };
      });
      state.rentalsTableData = initialData;
      state.rentalTotalPages = action.payload.totalPages;
    });
    builder.addCase(getAllRentals.rejected, (state, action) => {
      state.isLoading = false;
      state.errorMessage = action.error.message;
    });
  },
});

//eslint-disable-next-line
export const {
  toggleRentalFiltersUserFullNameState,
  toggleRentalFiltersLockerIdState,
  toggleRentalFiltersStartDateState,
  toggleRentalFiltersEndDateState,
  toggleRentalFiltersPageState,
  toggleClearRentallFiltersState,
  toggleClearRentalsTableData,
  toggleSelectedRentalReportType,
} = rentalSlice.actions;

export const rentals = (state) => state.rental.rentals;
export const rentalTotalPages = (state) => state.rental.rentalTotalPages;
export const rentalsData = (state) => state.rental.rentalsTableData;
export const rentalFilters = (state) => state.rental.rentalFilters;
export const selectedRentalReportTypes = (state) =>
  state.rental.selectedRentalReportType;

export default rentalSlice.reducer;
